export const MODAL_FONT_FAMILY = '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif';

export const createModalDesign = (theme) => {
  const dark = theme.palette.type === "dark";
  return {
    mdDialog: {
      "& .MuiDialog-paper": {
        fontFamily: MODAL_FONT_FAMILY,
        width: "min(520px, calc(100vw - 32px))",
        maxWidth: "calc(100vw - 32px)",
        borderRadius: 24,
        overflow: "hidden",
        background: dark
          ? "linear-gradient(180deg, #171a20 0%, #111319 100%)"
          : "#ffffff",
        boxShadow: dark
          ? "0 24px 80px rgba(0, 0, 0, 0.45)"
          : "0 24px 60px rgba(15, 23, 42, 0.12)",
        border: dark
          ? "1px solid rgba(255, 255, 255, 0.08)"
          : "1px solid rgba(15, 23, 42, 0.08)",
        "& *": {
          fontFamily: MODAL_FONT_FAMILY,
        },
      },
    },
    mdDialogWide: {
      "& .MuiDialog-paper": {
        width: "min(720px, calc(100vw - 32px))",
      },
    },
    mdHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(2.5, 3),
      borderBottom: dark
        ? "1px solid rgba(255, 255, 255, 0.06)"
        : "1px solid rgba(15, 23, 42, 0.08)",
    },
    mdTitle: {
      fontSize: "1.35rem",
      fontWeight: 700,
      color: dark ? "#f8fafc" : "#111827",
      lineHeight: 1.2,
    },
    mdCloseBtn: {
      color: dark ? "rgba(248, 250, 252, 0.72)" : "#6b7280",
    },
    mdContent: {
      padding: theme.spacing(3),
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2.5),
      maxHeight: "calc(100vh - 220px)",
      overflowY: "auto",
    },
    mdFieldLabel: {
      fontSize: 10,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.14em",
      color: dark ? "rgba(248, 250, 252, 0.5)" : "#9ca3af",
      marginBottom: 8,
      display: "block",
    },
    mdField: {
      width: "100%",
      "& .MuiOutlinedInput-root": {
        borderRadius: 14,
        background: dark
          ? "rgba(255, 255, 255, 0.05)"
          : "rgba(0, 0, 0, 0.02)",
        border: dark
          ? "1px solid rgba(91, 124, 255, 0.15)"
          : "1px solid rgba(0, 0, 0, 0.08)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        color: dark ? "#f8fafc" : "#0f172a",
        fontSize: "0.95rem",
        "& fieldset": {
          borderColor: "transparent",
        },
        "&:hover": {
          background: dark
            ? "rgba(255, 255, 255, 0.08)"
            : "rgba(61, 92, 253, 0.04)",
          border: dark
            ? "1px solid rgba(91, 124, 255, 0.25)"
            : "1px solid rgba(61, 92, 253, 0.15)",
          "& fieldset": { borderColor: "transparent" },
        },
        "&.Mui-focused": {
          background: dark
            ? "rgba(255, 255, 255, 0.08)"
            : "rgba(255, 255, 255, 1)",
          border: dark
            ? "1px solid rgba(91, 124, 255, 0.4)"
            : "1px solid rgba(61, 92, 253, 0.3)",
          boxShadow:
            "0 0 0 4px rgba(91, 124, 255, 0.15), 0 8px 24px rgba(91, 124, 255, 0.2)",
          "& fieldset": { borderColor: "transparent" },
        },
      },
      "& .MuiInputLabel-outlined": {
        color: dark ? "#94a3b8" : "#64748b",
        "&.Mui-focused": {
          color: dark ? "#a5b4fc" : "#3D5CFD",
        },
      },
    },
    mdFieldRow: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr",
      },
    },
    mdFieldRowThree: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gap: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr",
      },
    },
    mdSectionTitle: {
      fontSize: 11,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.12em",
      color: dark ? "rgba(248, 250, 252, 0.62)" : "#475569",
      paddingBottom: theme.spacing(0.5),
      borderBottom: dark
        ? "1px dashed rgba(255, 255, 255, 0.06)"
        : "1px dashed rgba(15, 23, 42, 0.08)",
    },
    mdActions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: 10,
      padding: theme.spacing(2, 3, 2.5),
      borderTop: dark
        ? "1px solid rgba(255, 255, 255, 0.06)"
        : "1px solid rgba(15, 23, 42, 0.08)",
    },
    mdBtnGhost: {
      height: 36,
      minWidth: 110,
      padding: "0 16px",
      borderRadius: 10,
      border: dark
        ? "1px solid rgba(255, 255, 255, 0.12)"
        : "1px solid rgba(15, 23, 42, 0.12)",
      background: "transparent",
      color: dark ? "rgba(248, 250, 252, 0.72)" : "#6b7280",
      fontSize: "0.875rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 180ms cubic-bezier(0.4, 0, 0.2, 1)",
      fontFamily: "inherit",
      textTransform: "none",
      "&:hover:not(:disabled)": {
        background: dark
          ? "rgba(255, 255, 255, 0.04)"
          : "rgba(15, 23, 42, 0.04)",
        color: dark ? "#f8fafc" : "#111827",
      },
      "&:disabled": { opacity: 0.5, cursor: "not-allowed" },
    },
    mdBtnPrimary: {
      height: 36,
      minWidth: 120,
      padding: "0 18px",
      borderRadius: 10,
      border: "none",
      background: "linear-gradient(135deg, #4f7cff 0%, #3b82f6 100%)",
      color: "#ffffff",
      fontSize: "0.875rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 180ms cubic-bezier(0.4, 0, 0.2, 1)",
      fontFamily: "inherit",
      textTransform: "none",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      boxShadow: "none",
      "&:hover:not(:disabled)": {
        background: "linear-gradient(135deg, #3f6cf0 0%, #2563eb 100%)",
      },
      "&:disabled": { opacity: 0.45, cursor: "not-allowed" },
    },
    mdSwitchRow: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      padding: theme.spacing(1.25, 1.5),
      borderRadius: 12,
      background: dark
        ? "rgba(255, 255, 255, 0.03)"
        : "rgba(248, 250, 252, 0.9)",
      border: dark
        ? "1px solid rgba(255, 255, 255, 0.08)"
        : "1px solid rgba(15, 23, 42, 0.08)",
    },
    mdSwitchLabel: {
      fontSize: "0.9rem",
      color: dark ? "#f8fafc" : "#111827",
      flex: 1,
    },
  };
};
